export enum ProductsEnum {
	ONLINE_USERS_ONLY = 'P_online_users_only',
	INTENTION_FILTER = 'P_intention_filter',
	ACTIVITY_LIKE = 'P_activity_like',
	RESTRICT_DM = 'P_restrict_dm',
	REWIND_LIKE = 'P_rewind_like',
	/* when user is very active he gets free coins */
	FREE_COINS = 'P_free_coins',
	/* When user paid coins */
	PAID_COINS = 'P_paid_coins',
	SEND_DM = 'P_dm_sent',
	/* When user paid for incognito or boost with fiat */
	PAID_INCOGNITO = 'P_paid_incognito',
	PAID_BOOST = 'P_paid_boost',
	/* Free bonus grants (milestone rewards, manual admin attribution) */
	BONUS_BOOST = 'P_bonus_boost',
	BONUS_INCOGNITO = 'P_bonus_incognito',
	/* The price of a paid event, and that price given back when the event is deleted */
	LIVE_EVENT_REGISTRATION = 'P_live_event_registration',
	LIVE_EVENT_REFUND = 'P_live_event_refund',
	STORE_REFUND = 'P_store_refund'
}
